import { Component, OnInit } from '@angular/core';
import * as dominiosBg from '../../../utilitarios/dominios-bg';
import * as dominiosLogo from '../../../utilitarios/dominios-logo';;
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  rutaInstitucion: string;
  bgInstitucion: string;
  logoInstitucion: string;
  constructor() { }
  ngOnInit(): void {
    this.rutaInstitucion = window.location.host.toString();
    this.bgInstitucion = dominiosBg.mapBg.get(this.rutaInstitucion);
    this.logoInstitucion = dominiosLogo.mapLogo.get(this.rutaInstitucion);
  }
}
